import React from 'react';
import {Link} from 'react-router-dom';
import LaddaButton, {XL, EXPAND_LEFT} from 'react-ladda';
import {toastr} from 'react-redux-toastr';
import {User} from 'api';
import isEmpty from 'lodash/isEmpty';
import {withRouter} from 'react-router';
import {parse} from 'qs';
import './_RestorePasswordForm.scss';

class RestorePasswordForm extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      newPassword: '',
      reTypeNewPassword: '',
      isSubmit: false
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const query = parse(this.props.location.search.substr(1));
    if (!query.access_token) {
      this.props.history.push('/forgot-password');
    }
  }

  onChange(e) {
    this.setState({[e.target.name]: e.target.value});
  }

  onSubmit(e) {
    e.preventDefault();
    if (!isEmpty(this.state.newPassword) && !isEmpty(this.state.reTypeNewPassword)) {
      const query = parse(this.props.location.search.substr(1));
      const data = {
        newPassword: this.state.newPassword
      };
      this.setState({isSubmit: true});
      User.actions.resetPassword.request({access_token: query.access_token}, {data}).then((response) => {
        this.setState({isSubmit: false});
        toastr.success('Thành công', 'Đổi mật khẩu thành công.');
        this.props.history.push('/thank-you');
      }).catch((error) => {
        this.setState({isSubmit: false});
        toastr.error('Lỗi!', 'Không thể khôi phục mật khẩu.');
      });
    } else {
      toastr.error('Lỗi!', 'Có lỗi xảy ra. Bạn vui lòng kiểm tra lại thông tin.');
    }
  }

  render() {
    const {newPassword, reTypeNewPassword, isSubmit} = this.state;
    return (
      <section className="restore-wrapper-D">
        <h2 className="restore-title">Đổi mật khẩu</h2>
        <form className="restore-form" onSubmit={this.onSubmit}>
          <div className="restore-input-group">
            <i className="fa fa-unlock-alt restore-icon"/>
            <input type="password" name="newPassword" value={newPassword} onChange={this.onChange} className="restore-input" placeholder="Mật khẩu mới..."/>
          </div>
          <div className="restore-input-group">
            <i className="fa fa-unlock-alt restore-icon"/>
            <input type="password" name="reTypeNewPassword" value={reTypeNewPassword} onChange={this.onChange} className="restore-input" placeholder="Nhập lại mật khẩu mới..."/>
          </div>
          <LaddaButton className="restore-btn" type="submit" data-size={XL} data-style={EXPAND_LEFT} loading={isSubmit}>Xác nhận đổi</LaddaButton>
        </form>
        <p className="restore-to-register">
          Bạn chưa có tài khoản?&nbsp;
          <Link className="register-link" to="/signup">Đăng kí ngay</Link>
        </p>
      </section>
    );
  }
}

export default withRouter(RestorePasswordForm);



// WEBPACK FOOTER //
// ./components/restore-password/RestorePasswordForm.jsx